import { formatPrice } from '@/core/currency/format';

export const ASV_SCANS_IP_COST = {
  amount: '9500',
  currency: 'USD',
  interval: 'year',
};

export function formatAsvScansIpCost() {
  const price = formatPrice(
    ASV_SCANS_IP_COST.amount,
    ASV_SCANS_IP_COST.currency,
    { short: true }
  );

  return `${price}/${ASV_SCANS_IP_COST.interval}`;
}

export const HOST_TYPE_ERRORS = {
  ip: 'Invalid IP address',
  ip_range: 'Invalid IP range',
  hostname: 'Invalid domain',
  default: 'Invalid host',
};
